import { useRequiredContext } from "@redotech/react-util/context";
import { LoadState, useLoad } from "@redotech/react-util/load";
import { InteractiveMapLocation } from "@redotech/redo-model/draft-return/draft-return";
import { RpcClientContext } from "../../contexts/rpc";

export interface BlueYonderLocationsResponse {
  locationsLoad: LoadState<InteractiveMapLocation[]>;
}

export const useBlueYonderLocations = (
  draftReturnId: string | undefined,
  returnId?: string | undefined,
): BlueYonderLocationsResponse => {
  const client = useRequiredContext(RpcClientContext);
  const locationsLoad: LoadState<InteractiveMapLocation[]> =
    useLoad(async () => {
      if (!draftReturnId && !returnId) {
        return [];
      }
      const { locations } = await client.getBlueYonderLocations({
        draftReturnId,
        returnId,
      });
      return locations;
    }, [draftReturnId, returnId, client]);

  return { locationsLoad };
};
